import type { TripLeg, TripModes } from '../../services/api'
import { formatShortClock } from '../../ui/transitTime'

// Shared helpers for the trip planner's components (a `.svelte` file can't export them).

export function fmtTime(epoch: number): string {
  return formatShortClock(epoch)
}

export function fmtDuration(seconds: number): string {
  const m = Math.round(seconds / 60)
  return m >= 60 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${m} min`
}

export function walkMinutes(leg: TripLeg): number {
  return Math.max(1, Math.round((leg.arrivalTime - leg.departureTime) / 60))
}

/** Add/remove one mode, refusing the empty selection (a trip has to ride something). */
export function toggleMode(modes: TripModes, mode: 'subway' | 'bus'): TripModes {
  const on = new Set(modes.split(',') as Array<'subway' | 'bus'>)
  if (on.has(mode)) {
    if (on.size === 1) return modes
    on.delete(mode)
  } else {
    on.add(mode)
  }
  return on.size === 2 ? 'subway,bus' : on.has('subway') ? 'subway' : 'bus'
}

export function optionsSummary(modes: TripModes, expressBus: boolean): string {
  const base =
    modes === 'subway,bus' ? 'Subway + Bus' : modes === 'subway' ? 'Subway only' : 'Bus only'
  // The express flag only bites when buses are in play, so only mention it then.
  return modes !== 'subway' && !expressBus ? `${base} · no express` : base
}
